import { hexToRgbaString } from '../../library/style/hexToRgbaString';
export const colorsCommon = {
  // Alert
  alert400: '#E27700',
  alert300: '#FF9900',
  alert200: '#FFC05C',
  alert100: '#FFF4E0',
  alertFaded: /*#__PURE__*/hexToRgbaString('#FBE0B5', 0.84),
  // Success
  success400: '#549116',
  success300: '#71B62C',
  success200: '#BEE19A',
  success100: '#F1F9E9',
  successFaded: /*#__PURE__*/hexToRgbaString('#EDF5E5', 0.78),
  // Help
  help400: '#154F8A',
  help300: '#0E83CD',
  help200: '#8BC7ED',
  help100: '#E6F3FC',
  helpFaded: /*#__PURE__*/hexToRgbaString('#E2EFF8', 0.78),
  // Error
  error300: '#C2212E',
  error200: '#FF0000',
  error100: '#FFE6E6',
  errorFaded: /*#__PURE__*/hexToRgbaString('#FBE2E2', 0.78),
  // Chick
  chick400: '#998000',
  chick300: '#F3C510',
  chick200: '#FEF0BA',
  chick100: '#FFFAE6',
  chickFaded: /*#__PURE__*/hexToRgbaString('#FEF6D6', 0.68),
  // neutralWarm
  neutralWarm300: '#EAEAEA',
  neutralWarm200: '#F2F2F2',
  neutralWarm100: '#F8F8F8',
  // neutralCold
  neutralCold200: '#CCDAE2',
  neutralCold100: '#ECF1F4',
  // Text
  black: '#000',
  white: '#FFF',
  whiteFaded: /*#__PURE__*/hexToRgbaString('#FFF', 0.2),
  // Grey
  grey500: '#3A3A3A',
  grey400: '#505050',
  grey300: '#888888',
  grey200: '#AAAAAA',
  grey100: '#CCCCCC',
  // Grey Opacity
  grey300Faded: /*#__PURE__*/hexToRgbaString('#3A3A3A', 0.6),
  grey200Faded: /*#__PURE__*/hexToRgbaString('#888888', 0.18),
  grey100Faded: /*#__PURE__*/hexToRgbaString('#E4E4E4', 0.5),
  transparent: 'transparent'
};
export const colorsSpecial = {
  promo: '#5195C2'
};
export const colorNamesThemed = ['primary500', 'primary400', 'primary300', 'primary200', 'primary100'];
export const fontColorNames = ['black', 'white', 'alert400', 'success300', 'success400', 'help300', 'help400', 'error300', 'chick400', 'grey100', 'grey200', 'grey300', 'grey400', 'grey500', 'primary300', 'primary400', 'primary500'];
export const borderColorNames = ['white', 'alert300', 'alert400', 'success300', 'success400', 'help300', 'help400', 'grey100', 'grey200', // 'grey300', if you need it, consider that in src/components/elements/BannerCta/BannerCta.css.ts#12 we have added custom css
'grey400', // 'neutralWarm300', if you need it, consider that in src/components/elements/Faq/Faq.css.ts#5 I have added custom css
// 'primary200', if you need it, consider that in src/components/blocks/Header/Header.css.ts#20 we have added custom css
'primary300', 'primary400'];
export const backgroundColorNames = ['white', 'whiteFaded', 'alert100', 'alert200', 'alert300', 'alert400', 'success100', 'success200', 'success300', 'success400', 'help100', 'help300', 'help400', 'chick100', 'error100', 'chick100', 'chick300', 'grey100', 'grey100Faded', 'grey200Faded', 'grey300Faded', 'grey400', 'grey500', 'neutralCold100', 'neutralWarm100', 'neutralWarm200', 'neutralWarm300', 'primary100', 'primary200', 'primary300', 'primary400', 'primary500'];
export const colorsTokensCommon = cs => ({
  colors: Object.assign(Object.assign({}, colorsCommon), cs)
});
//# sourceMappingURL=colorsCommon.js.map